// icons
import { Icon } from "@iconify/react"
// @mui
import { Box } from "@mui/material"
import type { SxProps } from "@mui/material"
import { forwardRef } from "react"

// ----------------------------------------------------------------------

const Iconify = forwardRef(
  (
    {
      icon,
      width = 20,
      sx,
      color = "inherit",
      ...other
    }: {
      icon: string
      width?: number | string
      sx?: SxProps
      color?: string
    },
    ref
  ) => (
    <Box
      ref={ref}
      component={Icon}
      icon={icon}
      {...other}
      sx={{
        color: color,
        width,
        height: width,
        ...sx,
      }}
    />
  )
)

Iconify.displayName = "Iconify"

export default Iconify
